import { isOCCSymbol } from '../occParser.js'
import { getMarketSession } from '../marketSession.js'
import { classifyContractSession } from './ibkrQuoteSubscriptionStore.js'

export function isOptionListCard(card) {
  return Boolean(card?.isOption || card?.assetType === 'option'
    || card?._quoteContract?.secType === 'OPT' || isOCCSymbol(card?.symbol))
}

// Presentation only: stale quotes can still have useful contract hours. Never
// inherit an equity's pre/post/overnight session or borrow its trading schedule.
export function optionListSession(card, now = Date.now()) {
  const contract = card?._quoteContract
  const scheduled = contract?.secType === 'OPT' ? classifyContractSession(contract, now) : null
  if (scheduled) return scheduled
  // Missing/expired schedules do not establish an extended option session.
  return getMarketSession(new Date(now)) === 'regular' ? 'regular' : 'closed'
}
